/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import cx from 'classnames'
import { Translate } from 'react-localize-redux'
import Skeleton from 'react-loading-skeleton'

import styles from './WrapperPage.module.scss'

import LoaderDefault from '../../UIKit/Loader'

import ErrorBoundary from '../ErrorBoundary'
import ArrowWithStick from '../../../../assets/images/ArrowWithStick'

interface IProps {
  title?: string,
  description?: string,
  isLoading?: boolean,
  handlerBack?: (...args: any) => void,
  Loader?: JSX.Element,
}

type IWrapperPage = React.HTMLAttributes<HTMLDivElement> & IProps

const WrapperPage: React.FC<IWrapperPage> = ({
  title,
  description,
  children,
  isLoading,
  className,
  handlerBack,
  Loader,
  ...props
}) => {
  return (
    <ErrorBoundary>
      <div className={cx(styles.root, className)} {...props}>
        {isLoading ?
          <>
            <Skeleton className={styles.titleLoad} />
            <Skeleton className={styles.descriptionLoad} />
            {Loader || <LoaderDefault />}
          </>
          :
          <>
            <div className={styles.header}>
              <div
                className={styles.title}
              >
                {typeof handlerBack === 'function' &&
                  <ArrowWithStick className={styles.arrow} onClick={typeof handlerBack === 'function' ? handlerBack : undefined} />
              }
                <Translate id={title || ''} />
              </div>
              <div className={styles.description}>
                <Translate id={description || ''} />
              </div>
            </div>
            {children}
          </>
      }
      </div>
    </ErrorBoundary>
  )
}

export default WrapperPage
